<script>
export const group = 'Bottom'
</script>

<script setup>
import { cdnImageUrl } from '@dpgradio/creative'
import { frames } from '../../../utils/frames'
import useDisappearable from '../../../composables/useDisappearable'
import TextSlideUpFade from './text_animations/TextSlideUpFade.vue'
import SlidingPill from './elements/SlidingPill.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const imageContainerElement = ref(null)
const imageElement = ref(null)

const timelineTitle = ref(null)
const timelineTitleOut = ref(null)
const timelineArtist = ref(null)
const timelineArtistOut = ref(null)
const timelinePill = ref(null)
const timelinePillOut = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'NowPlayingSmall' })
    .from(imageContainerElement, { scale: 0, duration: 0.5, ease: 'back.out(1.7)' })
    .from(imageElement, { scale: 0, duration: 0.3, ease: 'power2.out' }, '<.15')
    .add(timelineTitle, `<${frames(6, 50)}`)
    .add(timelineArtist, `<${frames(10, 50)}`)
    .add(timelinePill, `<${frames(16, 50)}`)
    .add(gsapTimeline({ repeat: -1, repeatDelay: 44 }).from(imageElement, { rotation: -360 * 2, duration: 16, ease: 'sine.inOut' }), `+=1`)
})

const { onDisappear } = useDisappearable()
onDisappear(
  async () =>
    await gsapTimeline({ name: 'NowPlayingSmall - End' })
      .add(timelineArtistOut.value(), `<`)
      .add(timelinePillOut.value?.(), `<${frames(2)}`)
      .add(timelineTitleOut.value(), `<${frames(4)}`)
      .to(imageContainerElement, { scale: 0, duration: 0.3, ease: 'power2.in' }, `<${frames(8)}`)
)

const track = computed(() => item.enrichment.track)
const activeEdition = computed(() => track.value.activeEditions?.[0])
</script>

<template>
  <div class="text-white flex items-center gap-10">
    <div ref="imageContainerElement" class="size-[172px] bg-joe-cr-rose-primary rounded-full p-6">
      <img v-if="track.thumbnail" ref="imageElement" :src="cdnImageUrl(track.thumbnail)" class="size-full rounded-full object-cover drop-shadow-lg" />
    </div>
    <div>
      <SlidingPill v-if="activeEdition" :text="`${activeEdition.list.name} - #${activeEdition.position}`" class="mb-2" @timeline="timelinePill = $event" @timelineOut="timelinePillOut = $event" />
      <TextSlideUpFade :text="track.title" class="text-7xl font-bold text-shadow-glow" @timeline="timelineTitle = $event" @timelineOut="timelineTitleOut = $event" />
      <TextSlideUpFade :text="track.artist.name" class="text-6xl text-shadow-glow" @timeline="timelineArtist = $event" @timelineOut="timelineArtistOut = $event" />
    </div>
  </div>
</template>
